import React, { useRef } from "react";
import { useContent } from "../../context/contentProvider";
import "./index.css";

export const ZoomLens = ({ imgUrl }) => {
    const magnifierWrapRef = useRef(null);
    const { setModal, setModalContent } = useContent();

    const getFilename = (url) => {
        const cleanedUrl = url.split('?')[0];
        const parts = cleanedUrl.split('/');
        const filenameWithExt = parts[parts.length - 1];
        
        const filename = filenameWithExt.replace(/\.[^/.]+$/, "");

        const camelCaseFilename = filename
            .replace(/_/g, ' ') // Replace underscores with spaces
            .replace(/\s(.)/g, match => match.toUpperCase()) // Convert spaces to CamelCase
            .replace(/^./, match => match.toLowerCase()); // Ensure the first letter is lowercase
        
        return camelCaseFilename;
    };

    const filename = getFilename(imgUrl);

    const handleMouseMove = (event) => {
        const magnifierWrap = magnifierWrapRef.current;
        const magnifierImage = magnifierWrap.querySelector('.magnifier--image');

        if (!magnifierWrap || !magnifierImage) return;

        const { left, top, width, height } = magnifierWrap.getBoundingClientRect();
        const x = (event.clientX - left) / width;
        const y = (event.clientY - top) / height;
        const scale = 1.3;

        magnifierImage.style.transformOrigin = `${x * 100}% ${y * 100}%`;
        magnifierImage.style.transform = `scale(${scale})`;
    };

    const handleMouseLeave = () => {
        const magnifierWrap = magnifierWrapRef.current;
        const magnifierImage = magnifierWrap.querySelector('.magnifier--image');

        if (!magnifierWrap || !magnifierImage) return;

        magnifierImage.style.transform = 'scale(1)';
    };

    const handleTouchMove = (event) => {
        const magnifierWrap = magnifierWrapRef.current;
        const magnifierImage = magnifierWrap.querySelector('.magnifier--image');

        if (!magnifierWrap || !magnifierImage) return;

        const { left, top, width, height } = magnifierWrap.getBoundingClientRect();
        const x = (event.touches[0].clientX - left) / width;
        const y = (event.touches[0].clientY - top) / height;
        const scale = 1.3;

        magnifierImage.style.transformOrigin = `${x * 100}% ${y * 100}%`;
        magnifierImage.style.transform = `scale(${scale})`;

        event.preventDefault();
    };

    const handleTouchEnd = () => {
        const magnifierWrap = magnifierWrapRef.current;
        const magnifierImage = magnifierWrap.querySelector('.magnifier--image');

        if (!magnifierWrap || !magnifierImage) return;

        magnifierImage.style.transform = 'scale(1)';
    };

    const handleImageClick = (imageUrl) => {
        setModalContent(<div className="slideshow-image-wrap"><img src={imageUrl} className="flex align-center mb-0 w-full" alt="Zoomlens" /></div>);
        setModal(true);
    };

    return (
        <>
            <div
                className="relative magnifier--wrap"
                ref={magnifierWrapRef}
                onMouseMove={handleMouseMove}
                onMouseLeave={handleMouseLeave}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
            >
                <img
                    src={imgUrl}
                    className="magnifier--image"
                    alt={filename}
                    onClick={() => handleImageClick(imgUrl)}
                />
            </div>
        </>
    );
};